import Accordion from './special/accordion.es6';
import Scroll from './special/scroll.es6';

const accordion = new Accordion();
const scroll = new Scroll();